module.exports = __webpack_public_path__ + "static/media/Pop_dark.e97ed377.svg";